import { useLazyQuery } from '@apollo/client/react';
import { useEffect, useMemo } from 'react';

import { GetAppointmentOnInsuranceCardDocument } from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';

type Props = {
  appointmentId: string | null;
};

export const useFetchAppointment = ({ appointmentId }: Props) => {
  const [getAppointment, { data, loading }] = useLazyQuery(GetAppointmentOnInsuranceCardDocument);

  const appointment = useMemo(() => {
    return getNode(data, 'Appointment');
  }, [data]);

  useEffect(() => {
    if (appointmentId) {
      getAppointment({
        variables: {
          id: appointmentId,
        },
      });
    }
  }, [appointmentId, getAppointment]);

  return {
    qualificationConfirmationMethod: appointment?.qualificationConfirmationMethod,
    isActivePatient: !!appointment?.patient?.active,
    loading,
  };
};
